import { render, staticRenderFns } from "./TemplateFileUploadCheckListCol.vue?vue&type=template&id=2df18a2c&scoped=true"
import script from "./TemplateFileUploadCheckListCol.vue?vue&type=script&lang=js"
export * from "./TemplateFileUploadCheckListCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df18a2c",
  null
  
)

export default component.exports